export enum DateFormatEnum {
  Full = 'MMM DD, YYYY hh:mma',
  Day = 'MMM DD, YYYY',
  FullShort = 'DD/MM/YY',
}
